const { user_roles } = require('BrdData/Enum');

// Site Title Configuration
const SITE_TITLE = 'HSC BRD';
const SITE_ICON = 'bird';
const APP_NAME = 'Bio Resource Directory';
const APP_DESCRIPTION =
  'This application serves as a searchable directory of biological ' +
  'resources available to researchers around the University of Utah.';
const ALLOW_APP_THEME_TOGGLE = false;

// ----------------------------------------------------------------------------------------
// ------------------------------- NAVIGATION ---------------------------------------------
// ----------------------------------------------------------------------------------------
let NAVIGATION = {};

// Navigation details for app pages. Used for menus, links, breadcrumbs, etc.
// The text entry is what will be displayed for menus or breadcrumbs with the exception being if there
// is a title present.  In that case, the title entry will be used for main navigation whereas the text
// entry will be used for breadcrumbs.
// The paths should match the paths in routes.
// The tabId field is used as react keys, so they should be unique.
const SITE_PAGES = {
  HOME: {
    text: 'Home',
    path: '/',
    icon: 'home',
    tabId: 'home',
    requiredAuth: {
      roles: Object.values(user_roles),
    },
  },
  DASHBOARD: {
    text: 'Dashboard',
    path: '/dashboard',
    icon: 'dashboard',
    tabId: 'dashboard',
  },
  BIOBANK_LANDING: {
    text: 'Bio Resources',
    path: '/bio-resource',
    icon: 'table',
    tabId: 'biobanks',
    requiredAuth: {
      roles: Object.values(user_roles),
    },
  },
  ALL_BIOBANKS: {
    text: 'All Bio Resources',
    path: '/bio-resource/all',
    icon: 'table',
    tabId: 'biobank-list',
    requiredAuth: {
      roles: Object.values(user_roles),
    },
  },
  BIOBANK_DETAIL: {
    text: 'Details',
    path: '/bio-resource/all',
    icon: 'package',
    tabId: 'biobank-detail',
    requiredAuth: {
      roles: Object.values(user_roles),
    },
  },
  ADMIN_LANDING: {
    title: 'Administration',
    text: 'Admin',
    path: '/admin',
    icon: 'shield',
    tabId: 'admin',
    requiredAuth: {
      roles: [user_roles.ADMINISTRATOR],
    },
  },
  MANAGE_USERS: {
    text: 'Manage Users',
    path: '/admin/users',
    icon: 'people',
    tabId: 'admin-users',
    requiredAuth: {
      roles: [user_roles.ADMINISTRATOR],
    },
  },
  USER_DETAILS: {
    icon: 'user',
    tabId: 'user-details',
    requiredAuth: {
      roles: [user_roles.ADMINISTRATOR],
    },
  },
  MY_PROFILE: {
    text: 'My Profile',
    path: '/my_profile',
    icon: 'user',
    tabId: 'my_profile',
  },
  HELP: {
    title: '',
    text: 'Help',
    path: '/help',
    icon: 'help',
    tabId: 'help',
  },
  ACCESS_DENIED: {
    path: '/access_denied',
  },
  LOG_IN: {
    title: 'Log In',
    icon: 'log-in',
    path: '/login',
  },
  LOG_OUT: {
    text: 'Log Out',
    icon: 'log-out',
    path: '/logout',
  },
};

// UPPER NAV BAR
// Main Links
NAVIGATION.navbarLinks = [SITE_PAGES.BIOBANK_LANDING, SITE_PAGES.MANAGE_USERS];

NAVIGATION.userAccountLinks = [
  SITE_PAGES.MY_PROFILE,
  SITE_PAGES.MANAGE_USERS,
  'DIVIDER',
  SITE_PAGES.LOG_OUT,
];

// Right menu items
NAVIGATION.navbarRightLinks_LoggedIn = [];

NAVIGATION.navbarRightLinks_LoggedOut = [SITE_PAGES.LOG_IN];

// SIDE NAVIGATION. (Items can have a sub-menu defined by 'menuItems'.)
// Links for upper side navigation menu.
NAVIGATION.sideNavbarLinks = [
  // SITE_PAGES.DASHBOARD,
  // SITE_PAGES.ALL_BIOBANKS,
  // {
  //   ...SITE_PAGES.ADMIN_LANDING,
  //   menuItems: [SITE_PAGES.MANAGE_USERS],
  // },
];

// Links for lower side navigation menu.
NAVIGATION.lowerSideNavbarLinks = [];

NAVIGATION.homePageLinks = [
  // SITE_PAGES.DASHBOARD,
  SITE_PAGES.BIOBANK_LANDING,
  SITE_PAGES.MANAGE_USERS,
  SITE_PAGES.LOG_OUT,
];

NAVIGATION.footerExternalLinks = [
  { text: 'HSC Cores Website', url: 'https://cores.utah.edu' },
];

const HELP_URL =
  'https://bookstack.cores.utah.edu/shelves/bio-resource-directory';
const HELP_EMAIL = 'help@cores.utah.edu';

// ----------------------------------------------------------------------------------------
// ------------------------------- END NAVIGATION -----------------------------------------
// ----------------------------------------------------------------------------------------

module.exports = {
  ALLOW_APP_THEME_TOGGLE,
  SITE_TITLE,
  SITE_ICON,
  APP_NAME,
  APP_DESCRIPTION,
  SITE_PAGES,
  NAVIGATION,
  HELP_URL,
  HELP_EMAIL,
};
